((scope) => {
  const createReviewSourceState = () => {
    let source = 'pending';
    let generation = 0;
    return {
      productArrived() {
        source = 'product';
        generation += 1;
        return source;
      },
      startFallback() {
        if (source === 'product') return null;
        source = 'storewide';
        generation += 1;
        return generation;
      },
      canCommitFallback(candidate) {
        return source === 'storewide' && candidate === generation;
      },
      get source() { return source; }
    };
  };
  const api = {create: createReviewSourceState};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (scope) scope.CozyologyReviewSourceState = api;
})(typeof window !== 'undefined' ? window : globalThis);
